export const ADMIN_EMAILS = [
  "yero.musique@gmail.com",
  "unlimitedsession@gmail.com",
];

export const CONTACT_EMAIL = "unlimitedsession@gmail.com";
export const LATDIOR_OFFICIAL_URL = "https://latdiorparis.com";

export const DEFAULT_PRICING = {
  currency: "EUR",
  studioHourly: 40,
  studioWithEngineer: 40,
  studioWithoutEngineer: 25,
  mixage: 260,
  mastering: 80,
  prod: 0,
};

export const DEFAULT_SERVICES = [
  {
    id: "mixage",
    title: "Mixage",
    priceKey: "mixage",
    description:
      "Equilibre, couleur, profondeur et impact pour un morceau pret a sortir.",
    uploadLabel: "Uploader les pistes a mixer",
  },
  {
    id: "mastering",
    title: "Mastering",
    priceKey: "mastering",
    description:
      "Derniere finition, niveau, coherence et export pret plateformes.",
    uploadLabel: "Uploader le mix final",
  },
  {
    id: "prod",
    title: "Prod",
    priceKey: "prod",
    description:
      "Production, beatmaking, direction sonore et accompagnement creatif.",
    uploadLabel: "Uploader refs / maquette",
  },
];

export const DEFAULT_LATDIOR_PRODUCTS = [
  {
    id: "latdior-2-pieces",
    name: "Ensemble 2 pieces",
    description: "Piece capsule Latdior, coupe premium et details Unlimited.",
    price: 220,
    image: "/images/latdior1.png",
    media: "/images/latdior1.png",
    mediaType: "image",
    externalUrl: LATDIOR_OFFICIAL_URL,
    sizes: ["S", "M", "L", "XL"],
    available: true,
  },
  {
    id: "latdior-3-pieces",
    name: "Ensemble 3 pieces",
    description: "Ensemble complet Latdior, pense comme un drop collector.",
    price: 560,
    image: "/images/latdior4.png",
    media: "/images/latdior4.png",
    mediaType: "image",
    externalUrl: LATDIOR_OFFICIAL_URL,
    sizes: ["S", "M", "L", "XL"],
    available: true,
  },
];

export const BOOKING_STATUSES = {
  pending: "en attente",
  confirmed: "confirmee",
  refused: "refusee",
  cancelled: "annulee",
};

export const ORDER_STATUSES = {
  pending: "en attente",
  paid: "paye",
  admin_validated: "valide admin",
  in_progress: "en cours",
  done: "termine",
  refused: "refuse",
};

export const LATDIOR_ORDER_STATUSES = {
  pending: "en attente",
  paid: "paye",
  preparing: "en preparation",
  shipped: "expedie",
  done: "termine",
  refused: "refuse",
};

export const STUDIO_MAX_HOURS = 8;
export const STUDIO_OPEN_HOUR = 0;
export const STUDIO_CLOSE_HOUR = 24;

export function formatCurrency(value, currency = "EUR") {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export function mergePricing(data) {
  const merged = { ...DEFAULT_PRICING, ...(data || {}) };
  if (data?.studioHourly && !data?.studioWithEngineer) {
    merged.studioWithEngineer = Number(data.studioHourly);
  }
  return merged;
}

export function getServicePrice(service, pricing) {
  return Number(pricing?.[service.priceKey] ?? service.basePrice ?? 0);
}

export function getStudioSlots() {
  return Array.from(
    { length: STUDIO_CLOSE_HOUR - STUDIO_OPEN_HOUR },
    (_, index) => `${String(STUDIO_OPEN_HOUR + index).padStart(2, "0")}:00`
  );
}

export function getStudioTimeBoundaries() {
  return Array.from(
    { length: STUDIO_CLOSE_HOUR - STUDIO_OPEN_HOUR + 1 },
    (_, index) => {
      const hour = STUDIO_OPEN_HOUR + index;
      return hour === 24 ? "24:00" : `${String(hour).padStart(2, "0")}:00`;
    }
  );
}

export function hoursBetween(startTime, endTime) {
  const start = Number(String(startTime || "0").split(":")[0]);
  const end = Number(String(endTime || "0").split(":")[0]);
  return Array.from({ length: Math.max(0, end - start) }, (_, index) => {
    const hour = start + index;
    return `${String(hour).padStart(2, "0")}:00`;
  });
}

export function dateToKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function slotDocId(dateKey, hour) {
  return `${dateKey}_${String(hour).replace(":", "")}`;
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
}

export function normalizeExternalUrl(raw) {
  if (!raw) return "";
  const value = String(raw).trim();
  if (value.startsWith("/") || /^https?:\/\//i.test(value)) return value;
  return `https://${value}`;
}

export function normalizeLatdiorProduct(docData, fallback = {}) {
  const merged = { ...fallback, ...(docData || {}) };
  return {
    id: merged.id,
    name: merged.name || "Produit Latdior",
    description: merged.description || "",
    price: Number(merged.price || 0),
    image: merged.image || "/images/latdior1.png",
    media: merged.media || merged.video || merged.image || "/images/latdior1.png",
    mediaType: merged.mediaType || (merged.video ? "video" : "image"),
    externalUrl: merged.externalUrl || LATDIOR_OFFICIAL_URL,
    sizes: Array.isArray(merged.sizes) && merged.sizes.length ? merged.sizes : ["S", "M", "L", "XL"],
    available: merged.available !== false,
  };
}
